import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const AIOpponent = ({ opponent, currentDialogue, isThinking }) => {
  const getMoodColor = (mood) => {
    switch (mood) {
      case 'Chaos':
        return 'var(--color-error)';
      case 'Confident':
        return 'var(--color-warning)';
      case 'Aggressive':
        return 'var(--color-secondary)';
      default:
        return 'var(--color-primary)';
    }
  };

  return (
    <div className="ai-opponent-container w-full">
      <div className="flex flex-col items-center gap-4 md:gap-6 lg:gap-8">
        <div className="relative">
          <div 
            className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 rounded-sm border-4 overflow-hidden shadow-glow-cyan-lg transition-all duration-base"
            style={{ borderColor: getMoodColor(opponent?.mood) }}
          >
            <Image
              src={opponent?.avatar}
              alt={opponent?.avatarAlt}
              className="w-full h-full object-cover pixelated"
            />
          </div>
          
          <div 
            className="absolute -top-2 -right-2 w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-sm border-2 flex items-center justify-center shadow-glow-magenta-md"
            style={{ 
              borderColor: getMoodColor(opponent?.mood),
              backgroundColor: 'var(--color-card)'
            }}
          >
            <Icon 
              name={opponent?.moodIcon} 
              size={24} 
              color={getMoodColor(opponent?.mood)} 
            />
          </div>

          {isThinking && (
            <div className="absolute inset-0 bg-background/80 rounded-sm flex items-center justify-center">
              <div className="flex gap-2">
                <div className="w-2 h-2 bg-primary rounded-sm animate-pulse" style={{ animationDelay: '0ms' }} />
                <div className="w-2 h-2 bg-primary rounded-sm animate-pulse" style={{ animationDelay: '150ms' }} />
                <div className="w-2 h-2 bg-primary rounded-sm animate-pulse" style={{ animationDelay: '300ms' }} />
              </div>
            </div>
          )}
        </div>

        <div className="text-center space-y-2">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold neon-text-cyan">
            {opponent?.name}
          </h2>
          <div 
            className="inline-flex items-center gap-2 px-4 py-2 rounded-sm border-2"
            style={{ 
              borderColor: getMoodColor(opponent?.mood),
              backgroundColor: `${getMoodColor(opponent?.mood)}20`
            }}
          >
            <span className="font-caption text-sm md:text-base tracking-wide" style={{ color: getMoodColor(opponent?.mood) }}>
              {opponent?.mood} MODE
            </span>
          </div>
        </div>

        <div className="w-full max-w-2xl">
          <div className="relative bg-card border-2 border-primary rounded-sm p-4 md:p-6 lg:p-8 shadow-glow-cyan-md">
            <div className="absolute -top-3 left-4 bg-card px-2 border border-primary rounded-sm">
              <span className="text-xs font-caption text-primary tracking-wide">AI TRANSMISSION</span>
            </div>
            
            <p className="text-sm md:text-base lg:text-lg font-body text-foreground leading-relaxed min-h-[60px] md:min-h-[80px]">
              {currentDialogue}
            </p>

            <div className="absolute bottom-2 right-2 flex gap-1">
              <div className="w-2 h-2 bg-accent rounded-sm animate-pulse" />
              <div className="w-2 h-2 bg-accent rounded-sm animate-pulse" style={{ animationDelay: '200ms' }} />
              <div className="w-2 h-2 bg-accent rounded-sm animate-pulse" style={{ animationDelay: '400ms' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIOpponent;